import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

const Index = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  
  // Only show the theme toggle after component mount to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  // If user is already logged in, redirect to dashboard
  if (user) {
    navigate("/dashboard");
  }
  
  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };
  
  return (
    <div className="min-h-screen w-full bg-background gradient-bg flex flex-col items-center justify-center p-4 transition-colors duration-300">
      <div className="absolute top-4 right-4">
        <Button 
          variant="ghost" 
          size="icon" 
          className="w-8 h-8 text-foreground/70 hover:text-foreground transition-colors"
          onClick={toggleTheme}
          aria-label={mounted && theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        >
          {mounted && (theme === "dark" ? <Sun size={16} /> : <Moon size={16} />)}
        </Button>
      </div>
      <div className="w-full max-w-md">
        <Card className="glass-card">
          <CardHeader className="space-y-1 text-center pb-2">
            <CardTitle className="text-3xl font-bold text-primary tracking-tighter">nativvshare</CardTitle>
            <p className="text-foreground/70 font-mono text-sm tracking-tight">Create and share images effortlessly</p>
          </CardHeader>
          <CardContent className="space-y-6 pt-4">
            <div className="text-foreground/60 text-sm font-mono space-y-2 bg-muted/50 dark:bg-black/20 p-3 rounded border border-black/5 dark:border-white/5 transition-colors">
              <p className="flex">
                <span className="text-primary mr-2">&gt;</span> 
                <span>Upload images to your personal gallery</span>
              </p>
              <p className="flex">
                <span className="text-primary mr-2">&gt;</span> 
                <span>Share with a custom link</span>
              </p>
              <p className="flex">
                <span className="text-primary mr-2">&gt;</span> 
                <span>Track views and engagement</span>
              </p>
            </div>
            <Button 
              onClick={() => navigate("/auth")}
              className="w-full bg-primary hover:bg-primary/90 font-mono tracking-tighter text-sm"
            >
              Get Started
            </Button>
            <div className="text-center text-xs text-foreground/40 font-mono">
              <p>© 2025 nativvshare • A project by nativv studios</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Index;
